module.exports = __webpack_public_path__ + "img/sponsor-4.0540e0f0.png";